import React, { useEffect, useState } from "react";
import { Row, Col, Button } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import SideMenu from "../Components/SideMenu";
import {
  compareGraphRecords,
  dashboardReporting,
} from "../reducers/commonReducer";
import moment from "moment";
import DateSelection from "./DateSelection";
import { loginUrl } from "../const";
import { useNavigate } from "react-router-dom";
import DashboardGraph from "./DashboardGraph";

const DashboardReport = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [dateRange1, setDateRange1] = useState([moment().subtract(1, "day").format("YYYY-MM-DD"), moment().subtract(1, "day").format("YYYY-MM-DD")]);
  const [dateRange2, setDateRange2] = useState([moment().format("YYYY-MM-DD"), moment().format("YYYY-MM-DD")]);

  useEffect(() => {
    dispatch(compareGraphRecords({
      startDate1 : dateRange1[0],
      endDate1 : dateRange1[1],
      startDate2 : dateRange2[0],
      endDate2 : dateRange2[1]
    }));
  }, []);
  const handleDateRangeChange = ([startDate, endDate]) => {
    // setStartDate(moment(startDate).format("DD/MM/YYYY"));
    // setEndDate(moment(endDate).format("DD/MM/YYYY"));
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const apiResp = await dispatch(
          dashboardReporting({
            startDate: moment().format("YYYY/MM/DD"),
            endDate: moment().format("YYYY/MM/DD"),
          })
        );
        if (apiResp?.type === "dashboardReporting/rejected") {
          if (localStorage.getItem("x-admin-token")) {
            localStorage.removeItem("x-admin-token");
            navigate(loginUrl);
          }
        }
      } catch (error) {
        console.error("API Error:", error);
      }
    };
    fetchData();
  }, [dispatch]);

  const { dashboardReportingData, compareGraphData } = useSelector(
    (state) => state.commonReducer
  );
  const totalOrders =
    +(dashboardReportingData?.paymenttypeData?.Prepaid || 0) +
    +(dashboardReportingData?.paymenttypeData?.COD || 0);

  const totalamount =
    +(dashboardReportingData?.amountData?.codChargesAmount || 0) +
    +(dashboardReportingData?.amountData?.shippingCost || 0) +
    +(dashboardReportingData?.amountData?.totalPaybleAmount || 0);

  const handleDateChange1 = (dates) => {
    setDateRange1(dates);
    dispatchData(dates, dateRange2); // Pass both date ranges to dispatch
  };

  const handleDateChange2 = (dates) => {
    setDateRange2(dates);
    dispatchData(dateRange1, dates); // Pass both date ranges to dispatch
  };
  const dispatchData = (dates1, dates2) => {
    if (dates1?.[0] && dates1?.[1] && dates2?.[0] && dates2?.[1]) {
      dispatch(
        compareGraphRecords({
          startDate1: moment(dates1?.[0]).format("YYYY-MM-DD"),
          endDate1: moment(dates1?.[1]).format("YYYY-MM-DD"),
          startDate2: moment(dates2?.[0]).format("YYYY-MM-DD"),
          endDate2: moment(dates2?.[1]).format("YYYY-MM-DD"),
        })
      );
    }
  };
  return (
    <>
      <div className="dboard">
        <SideMenu />
        <div className="mt-extra content container-fluid">
          <Row>
            <Col>
              <h6 className="text-danger text-center">
                Before update any name like Categories Name pls check{" "}
                <b>slug</b>.
              </h6>
            </Col>
          </Row>
          <Row className="mb-3">
            <Col md={4} sm={6} xs={6}>
              <DateSelection
                onDateRangeChange={handleDateRangeChange}
                api={dashboardReporting}
              />
            </Col>
            <Col md={8} sm={6} xs={6}>
              <Button
                variant="danger"
                className="float-right"
                onClick={() => {
                  window.location.reload();
                }}
              >
                Clear
              </Button>
            </Col>
            {/* <Col md={4} className="float-right">
              <label>Select Year</label>
              <Form.Select
                onChange={(e) =>
                  dispatch(
                    dashboardGraphs({
                      year: +e.target.value,
                    })
                  )
                }
              >
                <option>Select Year</option>
                <option value={moment().year()}>{moment().year()}</option>
                <option value={moment().year() - 1}>
                  {moment().year() - 1}
                </option>
                <option value={moment().year() - 2}>
                  {moment().year() - 2}
                </option>
                <option value={moment().year() - 3}>
                  {moment().year() - 3}
                </option>
                <option value={moment().year() - 4}>
                  {moment().year() - 4}
                </option>
                <option value={moment().year() - 5}>
                  {moment().year() - 5}
                </option>
              </Form.Select>
            </Col> */}
          </Row>
          {/* <div className="dashboard-bottom"></div> */}

          <Row>
            <Col md={3}>
              <div className="cards order-card shadow mb-3 animated-card">
                <div className="cards-body d-flex justify-content-between align-items-center">
                  <div>
                    <p className="cards-title fs-5">
                       Total
                      Orders
                    </p>
                  </div>
                  <div>
                    <h4 className="text-dark">{totalOrders}</h4>
                  </div>
                </div>
              </div>
            </Col>
            <Col md={3}>
              <div className="cards order-card shadow mb-3 animated-card">
                <div className="cards-body d-flex justify-content-between align-items-center">
                  <div>
                    <p className="cards-title fs-5">
                       Amount
                    </p>
                  </div>
                  <div>
                    <h4 className="text-dark">{totalamount}</h4>
                  </div>
                </div>
              </div>
            </Col>
            <Col md={3}>
              <div className="cards order-card shadow mb-3 animated-card">
                <div className="cards-body d-flex justify-content-between align-items-center">
                  <div>
                    <p className="cards-title fs-5">
                      Prepaid
                    </p>
                  </div>
                  <div>
                    <h4 className="text-dark">
                      {dashboardReportingData?.paymenttypeData?.Prepaid}{" "}
                      <span className="f-18 text-success">
                        (
                        {(
                          (dashboardReportingData?.paymenttypeData?.Prepaid *
                            100) /
                          totalOrders
                        )?.toFixed(1)}
                        %)
                      </span>
                    </h4>
                  </div>
                </div>
              </div>
            </Col>
            <Col md={3}>
              <div className="cards order-card shadow mb-3 animated-card">
                <div className="cards-body d-flex justify-content-between align-items-center">
                  <div>
                    <p className="cards-title fs-5"> COD
                    </p>
                  </div>
                  <div>
                    <h4 className="text-dark">
                      {dashboardReportingData?.paymenttypeData?.COD}{" "}
                      <span className="f-18 text-success">
                        (
                        {(
                          (dashboardReportingData?.paymenttypeData?.COD * 100) /
                          totalOrders
                        )?.toFixed(1)}
                        %)
                      </span>
                    </h4>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
          <Row>
            <Col md={3}>
              <div className="cards completed-order-card shadow mb-3 animated-card">
                <div className="cards-body d-flex justify-content-between align-items-center">
                  <div>
                    <p className="cards-title fs-5"> AOV
                    </p>
                  </div>
                  <div>
                    <h4 className="text-dark">
                      {(totalamount / totalOrders)?.toFixed(1)}/-
                    </h4>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
          <Row>
            {!!dashboardReportingData?.utmData &&
              Object.entries(dashboardReportingData?.utmData).map(
                ([key, value]) => {
                  return (
                    <Col md={3} key={key}>
                      <div className="cards payment-card shadow mb-3 animated-card">
                        <div className="cards-body d-flex justify-content-between align-items-center">
                          <div>
                            <p className="cards-title fs-5 text-capitalize">{key} Order
                            </p>
                          </div>
                          <div>
                            <h4 className="text-dark">{value || 0}</h4>
                          </div>
                        </div>
                      </div>
                    </Col>
                  );
                }
              )}
          </Row>
          <Row>
            <Col md={3}>
              <div className="cards completed-order-card shadow mb-3 animated-card">
                <div className="cards-body d-flex justify-content-between align-items-center">
                  <div>
                    <p className="cards-title fs-5"> CASH
                    </p>
                  </div>
                  <div>
                    <h4 className="text-dark">
                      {dashboardReportingData?.gatewayReport?.CASH}
                    </h4>
                  </div>
                </div>
              </div>
            </Col>
            <Col md={3}>
              <div className="cards completed-order-card shadow mb-3 animated-card">
                <div className="cards-body d-flex justify-content-between align-items-center">
                  <div>
                    <p className="cards-title fs-5"> EASEBUZZ
                    </p>
                  </div>
                  <div>
                    <h4 className="text-dark">
                      {dashboardReportingData?.gatewayReport?.EASEBUZZ}
                    </h4>
                  </div>
                </div>
              </div>
            </Col>
            <Col md={3}>
              <div className="cards completed-order-card shadow mb-3 animated-card">
                <div className="cards-body d-flex justify-content-between align-items-center">
                  <div>
                    <p className="cards-title fs-5">PAYU
                    </p>
                  </div>
                  <div>
                    <h4 className="text-dark">
                      {dashboardReportingData?.gatewayReport?.PAYU}
                    </h4>
                  </div>
                </div>
              </div>
            </Col>
            <Col md={3}>
              <div className="cards completed-order-card shadow mb-3 animated-card">
                <div className="cards-body d-flex justify-content-between align-items-center">
                  <div>
                    <p className="cards-title fs-5"> RAZORPAY
                    </p>
                  </div>
                  <div>
                    <h4 className="text-dark">
                      {dashboardReportingData?.gatewayReport?.RAZORPAY}
                    </h4>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
          <Row className="mb-3">
            <Col md={12} sm={12} xs={12}>
              <h2>Compare Data</h2>
              <hr />
            </Col>
            <Row>
              <Col md={2}>
                <DateSelection
                  onDateRangeChange={handleDateChange1}
                  label="Start"
                  graph={true}
                />
              </Col>
              <Col md={2}>
                <DateSelection
                  onDateRangeChange={handleDateChange2}
                  label="End"
                  graph={true}
                />
              </Col>
            </Row>
            <Col md={6}>
              <h1 className="text-center text-black">
                <b>Orders</b>
              </h1>
              {!!compareGraphData?.data1 && !!compareGraphData?.data2 ? (
                <DashboardGraph
                  title={"Top City"}
                  graphData={compareGraphData?.data1}
                  graphData2={compareGraphData?.data2}
                  type={2}
                  labelType={compareGraphData?.interval}
                />
              ) : (
                <h2>Loading........</h2>
              )}
            </Col>
            <Col md={6}>
              <h1 className="text-center text-black">
                <b>Amount</b>
              </h1>
              {!!compareGraphData?.data1 && !!compareGraphData?.data2 ? (
                <DashboardGraph
                  title={"Top City"}
                  graphData={compareGraphData?.data1}
                  graphData2={compareGraphData?.data2}
                  type={1}
                  labelType={compareGraphData?.interval}
                />
              ) : (
                <h2>Loading........</h2>
              )}
            </Col>
          </Row>
          {/* <Row className="mb-3">
            <Col md={6}>
              <h1 className="text-center text-black">
                <b>Cod Charges Amount</b>
              </h1>
              {!!compareGraphData?.data1 && !!compareGraphData?.data2 ? (
                <DashboardGraph
                  title={"Top City"}
                  graphData={compareGraphData?.data1}
                  graphData2={compareGraphData?.data2}
                  type={2}
                />
              ) : (
                <h2>Loading........</h2>
              )}
            </Col>
          </Row> */}
        </div>
      </div>
    </>
  );
};

export default DashboardReport;
